import { fg } from '@atlassian/jira-feature-gating';

export default {
	get(): boolean {
		return fg('jcs_project_type_m3');
	},
};
